<div *ngIf="isPopupOpen">
  <div class="popup-container" >

    <div class="popup-header">
      <h3>CPN-MSN Explorer</h3>
      <span class="close-btn" (click)="closePopup()">×</span>
    </div>

    <div class="popup-body">
      <div class="cpn-search-wrapper">
        <div class="cpn-search-header">
          <input type="text" placeholder="Enter CPN No."   [(ngModel)]="cpn"  (keyup.enter)="fetchCustomers()"/>
          <button  class="cpnSrch"  (click)="fetchCustomers()">
            <mat-icon class="mat-icon material-icons mat-icon-no-color">
              <i class="material-icons">search</i>
            </mat-icon>
          </button>
        </div>
        <div class="cpn-search-empty-state" *ngIf="!customerLoading && customers.length === 0">
          <div class="cpn-icon-circle">
            <span>⌕</span>
          </div>
          <p class="cpn-title">Enter an CPN ID &amp; Customer Name to search</p>
          <p class="cpn-subtitle">Results will appear here</p>
        </div>

        <div class="cpn-product-wrapper">

          <div class="mcaccordion" *ngIf="1">

  <div
    class="mcaccordion-item"
    *ngFor="let customer of customers; let i = index">

    <div
      class="mcaccordion-header"
      (click)="toggleAccordion(i, customer)">

      <span>{{ customer.customerName }}</span>

      <span class="mcAccorIconCon">
        {{ activeAccordion === i ? '-' : '+' }}
      </span>

    </div>

    <div
      class="mcaccordion-body"
      *ngIf="activeAccordion === i">

      <div
        class="cpn-product-card"
        *ngFor="let msn of mappedMsns[customer.customerName]">

        <div class="cpn-product-top">

          <div class="cpn-product-left">

            <span
              class="cpn-status"
              [ngClass]="{
                'cpn-status--active': msn.currentStatus,
                'cpn-status--unused': !msn.currentStatus
              }">

              <!-- <span class="cpn-status-dot"></span> -->

              {{ msn.currentStatus ? 'Current' : 'Historical' }}

            </span>
            <strong class="cpnStatusActive" [ngClass]="msn.active ? '':'cpn-status--inactive'" >{{msn.active?'Active':'Inactive'}}</strong>
            <h3 class="cpn-product-id">
              {{ msn.msn }}
            </h3>

          </div>

          <div class="cpn-product-right">

            <span class="cpn-tag">
              {{ msn.type }}
            </span>

            <button
              class="cpn-arrow-btn"
              (click)="openProduct(msn.msn)">
              ↗
            </button>

          </div>

        </div>

        <div class="cpn-product-meta">

          <!-- <span class="cpn-product-desc">
            Status: 
            <strong class="cpnStatusActive" [ngClass]="msn.active ? '':'cpn-status--inactive'" >{{msn.active?'Active':'Inactive'}}</strong>
          </span> -->
          <span  class="cpn-product-desc">
            Brand:
            <strong>{{ msn.brandName || '-' }}</strong>
          </span>

          <span  class="cpn-product-desc">
            UOM:
            <strong>{{ msn.uom || '-' }}</strong>
          </span>

        </div>

        <p class="cpn-product-desc">

          Description:
          <strong>
            {{ msn.msnName || '-' }}
          </strong>

        </p>

      </div>
    </div>

  </div>

          </div>

        </div>

      </div>
    </div>

  </div>

   <div class="popup-overlay" *ngIf="isPopupOpen" (click)="closePopup()"></div>

</div> 